export const REGION_EMEA = "emea";
export const REGION_NA = "na";
export const REGION_SA = "sa";
export const REGION_CN = "cn";
export const REGION_ROA = "roa";
export const REGIONS = {};

REGIONS[REGION_EMEA] = {
  label: "Europe, Middle-East, Africa",
  distanceUnit: "mm"
};
REGIONS[REGION_NA] = { label: "North America", distanceUnit: "inch" };
REGIONS[REGION_SA] = { label: "South America", distanceUnit: "mm" };
REGIONS[REGION_CN] = { label: "Greater China", distanceUnit: "mm" };
REGIONS[REGION_ROA] = { label: "Rest of Asia", distanceUnit: "mm" };

export const CAUSES = {
  NO_OPERATING_POINT: "The selected module cannot operate at given input.",
  NO_MATCHING_DRIVER: "Your selection did not match any driver.",
  NO_VALID_SYSTEM:
    "Your selected module is not compatible with the driver in your solution. Please consider removing the driver from solution or changing your module operating conditions."
};

// All defined roles in EDIT
export const IMPORT_STATUS = "IMPORT_STATUS";
export const RTH_MODULE_CALCULATIONS = "RTH_MODULE_CALCULATIONS";
export const CAN_SEE_COMPANY_PORTFOLIO = "CAN_SEE_COMPANY_PORTFOLIO";
export const MAINTENANCE_MODE = "MAINTENANCE_MODE";
export const EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO =
  "EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO";
export const IMPORT_PDF_SELECTION = "IMPORT_PDF_SELECTION";
export const SHOW_DOWNLOAD_BUTTON = "SHOW_DOWNLOAD_BUTTON";
export const SHOW_DOWNLOAD_PDF_BUTTON = "SHOW_DOWNLOAD_PDF_BUTTON";
export const VIEW_ARCHIVE_IN_ADMIN = "VIEW_ARCHIVE_IN_ADMIN";
export const WHITELIST_WRITE = "WHITELIST_WRITE";
export const MAINTENANCE_MODE_FRONTEND = "MAINTENANCE_MODE_FRONTEND";
export const WRITE_MODULES = "WRITE_MODULES";
export const ARCHIVE = "ARCHIVE";
export const IMPERSONATE = "IMPERSONATE";
export const ROYAL_FLUSH = "ROYAL_FLUSH";
export const GLOBAL_REGION_FLUSH = "GLOBAL_REGION_FLUSH";
export const EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO =
  "EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO";
export const READ_MODULES = "READ_MODULES";
export const EXPORT_USER_CATALOG = "EXPORT_USER_CATALOG";
export const ASSUME_ROLE = "ASSUME_ROLE";
export const MAX_VF_AND_MIN_LUM_FLUX = "MAX_VF_AND_MIN_LUM_FLUX";
export const WHITELIST_READ_ALL = "WHITELIST_READ_ALL";
export const WHITELIST = "WHITELIST";
export const EXPORT_ACL_MATRIX = "EXPORT_ACL_MATRIX";
export const WRITE_DRIVERS = "WRITE_DRIVERS";
export const READ_DRIVERS = "READ_DRIVERS";
export const EDIT_DRIVERS = "EDIT_DRIVERS";
export const MAINTENANCE_MODE_ADMIN = "MAINTENANCE_MODE_ADMIN";
export const ADMIN_PANEL = "ADMIN_PANEL";
export const REGION_FLUSH = "REGION_FLUSH";
export const GENERATE_M1_QR_FILE = "GENERATE_M1_QR_FILE";
export const THERMAL_POWER_PER_LED_PACKAGE = "THERMAL_POWER_PER_LED_PACKAGE";
export const WHITELIST_READ = "WHITELIST_READ";
export const EFFICACY_BASED_CALCULATIONS = "EFFICACY_BASED_CALCULATIONS";
export const ENABLE_WHITELISTING_FILTER = "ENABLE_WHITELISTING_FILTER";
export const COMPARE = "COMPARE";
export const COMPANY_FLUSH = "COMPANY_FLUSH";
export const DOWNLOAD_CSV_TEMPLATE = "DOWNLOAD_CSV_TEMPLATE";
export const EDIT_MODULES = "EDIT_MODULES";
export const ACCESS_SUPER_ADMIN_TAB = "ACCESS_SUPER_ADMIN_TAB";
export const VIEW_ARCHIVE = "VIEW_ARCHIVE";
export const GENERATE_M1_FEATURE_FILE = "GENERATE_M1_FEATURE_FILE";
export const ENABLE_HAS_MATCHING_DRIVER_FILTER =
  "ENABLE_HAS_MATCHING_DRIVER_FILTER";
export const EMERGENCY_DRIVERS = "EMERGENCY_DRIVERS";

export const MAX_COMPARE_PRODUCTS = 3;
